/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const data = {
    header: 'Inspiration in Art: A Gallery of Floral Hearts',
    url: '/kristina-libby',
    slider: [
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-09-17-16-28-40-559.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-09-17-16-31-24-374.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-09-17-16-31-50-198.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-09-17-16-32-57-026.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-09-17-16-33-20-175.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-09-17-16-34-46-976.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-09-17-16-37-44-967.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-09-17-16-38-24-043.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2021/lp/klibby/image-2021-08-24-10-28-25-428.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2021/lp/klibby/image-2021-08-24-10-29-39-609.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2021/lp/klibby/image-2021-08-24-10-29-59-780.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2021/lp/klibby/image-2021-08-24-10-30-29-410.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2021/lp/klibby/image-2021-08-24-10-31-47-927.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2021/lp/klibby/image-2021-08-24-10-33-38-357.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2021/lp/klibby/image-2021-08-24-10-34-00-755.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2021/lp/klibby/image-2021-08-24-10-34-13-719.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2021/lp/klibby/image-2021-08-24-10-34-37-161.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-06-10-10-36-49-208.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-06-10-10-37-04-626.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-06-10-10-37-21-923.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-06-10-10-37-36-161.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-06-10-10-38-53-988.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-06-10-10-39-16-337.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-06-10-10-36-35-048.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-03-08-16-06-08-550.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-03-08-16-06-36-920.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-03-08-16-07-40-306.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-03-08-16-08-01-908.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-03-08-16-08-27-603.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-03-08-16-08-51-538.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-03-08-16-09-08-446.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-03-08-16-09-35-492.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-03-08-16-09-47-299.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-2021-03-08-16-10-04-649.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-1.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-2.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-3.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-4.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-5.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-6.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-7.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-8.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-9.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-10.png',
            alt: '',
        },
        {
            image: '//cdn4.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floral-heart-11.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-20210120-191137.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-20210120-191155.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-20210120-191217.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/image-20210120-191305.png',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/FortTyron-3.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/FortTyron-10.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/FortTyron-29.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/FortTyron-30.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/FortTyron-31.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/FortTyron-39.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/FortTyron-69.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/Rockaway-Beach-w-NewYork-Next_floralrockaway-25.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/Rockaway-Beach-w-NewYork-Next_floralrockaway-49.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/Rockaway-Beach-w-NewYork-Next_floralrockaway-70.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/Rockaway-Beach-w-NewYork-Next_floralrockaway-79.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/Rockaway-Beach-w-NewYork-Next_floralrockaway-81.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/Rockaway-Beach-w-NewYork-Next_floralrockaway-84.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/Rockaway-Beach-w-NewYork-Next_floralrockaway-86.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/Rockaway-Beach-w-NewYork-Next_floralrockaway-87.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/Rockaway-Beach-w-NewYork-Next_floralrockaway-92.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/Rockaway-Beach-w-NewYork-Next_floralrockaway-100.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/GreelySquare-11.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/GreelySquare-12.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/GreelySquare-13.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/GreelySquare-24.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/GreelySquare-28.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/GreelySquare-32.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/GreelySquare-69.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/GreelySquare-76.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/GreelySquare-78.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/GreelySquare-81.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-10.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-14.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-25.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-33.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-45.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-57.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-70.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-72.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-74.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-76.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/TimesSquare/floralheartsTS-93.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floralheartsTS-10.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floralheartsTS-14.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floralheartsTS-17.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floralheartsTS-19.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floralheartsTS-21.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floralheartsTS-40.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/floralheartsTS-63.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/BryantPark-6.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/BryantPark-32.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/BryantPark-36.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/BryantPark-48.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/BryantPark-69.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/BryantPark-80.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/HeraldSquare-6.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/HeraldSquare-22.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/HeraldSquare-47.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/HeraldSquare-52.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/HeraldSquare-72.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/HeraldSquare-73.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/HeraldSquare-76.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-1.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-2.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-3.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-4.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-5.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-6.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-7.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-8.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-9.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-10.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-11.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-12.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-13.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-14.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-15.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-16.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-17.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-18.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-19.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-20.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-21.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-22.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-23.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-24.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-25.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-26.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-27.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-28.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-29.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-30.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-31.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-32.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-33.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-34.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-35.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-36.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-37.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-38.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-39.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-40.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-41.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-42.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-43.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-44.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-45.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-46.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-47.jpg',
            alt: '',
        },
        {
            image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2020/lp/klibby/klibby-gallery-image-48.jpg',
            alt: '',
        },

    ],
};

export default data;
